/**
 * It removes a element from an array which evaluates to true on applying function cb and returns it.
 *
 * @param array
 * @param cb
 * @param fallback
 *
 * @returns */
export const findOnArrayAndRemove = <T, R = T>(
  array: T[],
  cb: (item: T, index: number, arr: T[]) => boolean,
  fallback: R
): T | R => {
  const index = array.findIndex(cb);

  if (index === -1) {
    return fallback;
  }

  return array.splice(index, 1)[0];
};

/**
 * Returns new array with the given index removed.
 *
 * @param array
 * @param index
 *
 * @returns */
export const filterFromIndex = <T>(array: T[], index: number): T[] => {
  const result = [...array];

  result.splice(index, 1);

  return result;
};
/**
 *
 * @param array
 * @returns last item from array
 */
export const getLastItemFromArray = <T>(array: T[]): T | undefined => array.slice(-1)[0];

/**
 * Function to map array to object.
 * for eg array [1,2,4,5]  is mapped to object { 1:1, 2:2, 4:4, 5:5 }
 *
 * @param array
 * @returns */
export const getObjectFromArray = <T extends string | number>(array: T[]): Record<string, T> =>
  array.reduce((prev, current) => ({ ...prev, [String(current)]: current }), {});

/**
 * Return common elements between two arrays.
 *
 * @param a
 * @param b
 */
export function intersect<T>(a: T[], b: T[]): T[] {
  return a.filter(Set.prototype.has, new Set(b));
}

/**
 * Returns abbreviations of stringa with spaces excluding passed param
 *
 * @param array
 * @param exclude
 */
export const abbreviationsArray = (array: string[], exclude: string[]): string[] => {
  return array.map((str) => {
    if (str.indexOf(' ') === -1 || exclude.includes(str)) {
      // Check if the string has no spaces or is in the exclude array
      return str;
    } else {
      return str
        .split(' ')
        .map((word) => {
          return word.charAt(0).toUpperCase();
        })
        .join('');
    }
  });
};

/**
 * Returns unique elements in an array
 *
 * @param array
 */
export function getUniqueElements<T>(array: T[]): T[] {
  const uniqueElement = new Set(array);

  return [...uniqueElement];
}
